import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Modal from '@cloudscape-design/components/modal';
import Input from '@cloudscape-design/components/input';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import FormField from '@cloudscape-design/components/form-field';
import Textarea from '@cloudscape-design/components/textarea';
import Tabs from '@cloudscape-design/components/tabs';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { brandLicensesEditModalStore } from '../stores/brandLicensesEditModal';

class BrandLicensesEditModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			jsonError: '',
		};
	}


	resetFormFields = () => {
		const { setBrandLicensesEditModal, brandLicensesEditModal } = this.props;
		setBrandLicensesEditModal({
			...brandLicensesEditModal,
			show: false,
			formData: {
				company: '',
				license_name: '',
				license_number: '',
				license_country: '',
				license_address: '',
				license_url: '',
				license: '',
				image_path: '',
				domain: '',
				ltd: '',
				translate: '',
			},
			jsonData: '',
			error: {
				text: '',
				code: 0,
				timestamp: 0,
			},
		});
		this.setState({ jsonError: '' });
	};

	updateFormField = (key, value) => {
		const { brandLicensesEditModal, setBrandLicensesEditModal } = this.props;
		const updatedState = cloneDeep(brandLicensesEditModal);
		updatedState.formData[key] = value;
		updatedState.jsonData = JSON.stringify(updatedState.formData, null, 2);
		setBrandLicensesEditModal(updatedState);
	};

	handleJsonChange = (value) => {
		const { brandLicensesEditModal, setBrandLicensesEditModal } = this.props;
		const updatedState = cloneDeep(brandLicensesEditModal);
		updatedState.jsonData = value;
		try {
			const parsed = JSON.parse(value);
			updatedState.formData = parsed;
			this.setState({ jsonError: '' });
		} catch (error) {
			this.setState({ jsonError: 'Invalid JSON format' });
		}
		setBrandLicensesEditModal(updatedState);
	};

	updateBrandLicense = async () => {
		const { brandLicensesEditModal, Interface } = this.props;
		const { jsonError } = this.state;

		if (jsonError) {
			Interface.addNoty('Error', 'Please fix JSON before saving');
			return;
		}

		try {
			const body = {
				...brandLicensesEditModal.formData,
			};

			const result = await Interface.request('set', {
				class: 'data',
				module: 'brandLicenses',
				method: 'edit',
			}, body);

			Interface.addNoty('Success', 'Brand license updated successfully');
			Interface.loadBrandLicenses();
			this.resetFormFields();
		} catch (error) {
			Interface.addNoty('Error', error.text || error.toString());
		}
	};

	render() {
		const { brandLicensesEditModal, setBrandLicensesEditModal } = this.props;
		const { jsonError } = this.state;

		const formFields = [
			{ key: 'company', label: 'Company' },
			{ key: 'license_name', label: 'License Name' },
			{ key: 'license_number', label: 'License Number' },
			{ key: 'license_country', label: 'License Country' },
			{ key: 'license_address', label: 'License Address' },
			{ key: 'license_url', label: 'License URL' },
			{ key: 'license', label: 'License Text', textarea: true },
			{ key: 'image_path', label: 'Image Path' },
			{ key: 'domain', label: 'Domain' },
			{ key: 'ltd', label: 'LTD', textarea: true },
			{ key: 'translate', label: 'Translate', textarea: true },
		];

		return (
			<Modal
				visible={brandLicensesEditModal.show}
				size="medium"
				onDismiss={() => setBrandLicensesEditModal({ ...brandLicensesEditModal, show: false })}
				header="Edit Brand License"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button variant="normal" onClick={this.resetFormFields}>
								Close
							</Button>
							<Button variant="primary" onClick={this.updateBrandLicense}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<Tabs
					tabs={[
						{
							label: 'Form',
							id: 'form',
							content: (
								<SpaceBetween direction="vertical" size="l">
									{formFields.map(({ key, label, textarea }) => (
										<FormField key={key} label={label}>
											{textarea ? (
												<Textarea
													value={brandLicensesEditModal.formData[key]}
													onChange={({ detail }) => this.updateFormField(key, detail.value)}
												/>
											) : (
												<Input
													value={brandLicensesEditModal.formData[key]}
													onChange={({ detail }) => this.updateFormField(key, detail.value)}
												/>
											)}
										</FormField>
									))}
								</SpaceBetween>
							),
						},
						{
							label: 'JSON',
							id: 'json',
							content: (
								<FormField label="JSON Editor" errorText={jsonError}>
									<Textarea
										value={brandLicensesEditModal.jsonData || JSON.stringify(brandLicensesEditModal.formData, null, 2)}
										onChange={({ detail }) => this.handleJsonChange(detail.value)}
										rows={15}
									/>
								</FormField>
							),
						},
					]}
				/>
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const brandLicensesEditModal = useRecoilValue(brandLicensesEditModalStore);
		const setBrandLicensesEditModal = useSetRecoilState(brandLicensesEditModalStore);

		return (
			<Component
				{...props}
				setBrandLicensesEditModal={setBrandLicensesEditModal}
				brandLicensesEditModal={brandLicensesEditModal}
			/>
		);
	};
}

export default withRecoil(BrandLicensesEditModal);